import PropTypes from 'prop-types'
import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from 'gatsby-image'

const query = graphql`
  query {
    allImageSharp {
      edges {
        node {
          fluid{
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
  }
`
const Image = ({alt, className, imageName}) => {

  const data = useStaticQuery(query);
  return (
      <Img alt={alt} className={className} fluid={data.allImageSharp.edges.find( element => {
      // Match string after final slash
      return (element.node.fluid.src.split('/').pop() === imageName);
    }).node.fluid} /> 
  )
}

Image.propTypes = {
  imageName: PropTypes.string,
  className: PropTypes.string,
  alt: PropTypes.string,
}

export default Image